import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventLabel, GaTrackingEventName, GATrackingEventType } from '../../constants';
import { Product } from '~shared/models';
import get from 'lodash.get';
import {
  ZRPCategoryClickedApplicationEvent
} from '~shared/modules/application-event/models/zrp-category-clicked-application-event.model';

export class GATrackingZRPCategoryClickedApplicationEvent implements GATrackingEvent {

  constructor(private categoryName: string,
              private pageTitle: string) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ZRPCategoryClicked;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.ZRPCategoryClicked,
      label: this.categoryName
    };
  }
  getGtmDataLayerTitle() {
    return this.pageTitle;
  }
}
